<!--申请风险金-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template #next>
          <el-button type="primary" :loading="subLoading" @click="batchDraft">批量下发</el-button>
          <el-button type="primary" :loading="subLoading" @click="batchRej">批量退回</el-button>
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        row-key-field="id"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        border
        show-selection
        :selectable="selectable"
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
        ref="editTable"
        :tool-bar="{
          label: '操作',
          hidden: true,
          width: '140px',
          align: 'center',
        }"
      >
        <template #taskState="{row}">
          <el-tag v-if="row.taskState === 'D'">待审批</el-tag>
          <el-tag v-if="row.taskState === 'N'">已分配</el-tag>
          <el-tag v-if="row.taskState === 'Y'">已完成</el-tag>
          <el-tag v-if="row.taskState === 'T'">回退</el-tag>
          <el-tag v-if="row.taskState === 'C'">已转交</el-tag>
        </template>
<!--        <template #toolbar="scope">-->
<!--          <el-button type="text" size="mini" @click="batchDraft(scope.row)">批量下发</el-button>-->
<!--          <el-button type="text" size="mini" @click="batchRej(scope.row)">批量退回</el-button>-->
<!--        </template>-->
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import {tableSataus} from '@/views/bill/mixins/status'
import initDict from "@/mixin/initDict";
import { parseTime} from "@/utils";
import {updateState,downloadExcel} from "@/api/bill/task-list";
export default {
  name: "PartnerBudgetTask",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin,tableSataus,initDict],
  data() {
    return {
      tableHead: [
        {
          label: "项目名",
          prop: "projectName",
          query: {
            type: "input"
          }
        },
        {
          label: "项目号",
          prop: "projectCode",
          query: {
            type: "input"
          }
        },
        {
          label: "节点编号",
          prop: "nodeCode",
          query: {
            type: "input"
          }
        },
        {
          label: "节点名称",
          prop: "nodeName",
        },
        {
          label: "终端客户",
          prop: "customerName",
        },
        {
          label: "执行人",
          prop: "receiverName",
          query: {
            type: "input"
          }
        },
        {
          label: "任务内容",
          prop: "taskContent",
        },
        {
          label: "任务开始时间",
          prop: "plannedStartTime",
          query: {
            type: "datetimerange",
            valueFormat: "yyyy-MM-dd",
            clearable: false
          },
          formatter: (val) => {
            if (val) {
              return val.replace('00:00:00', '')
            } return val
          },
          width: 140
        },
        {
          label: "任务结束接时间",
          prop: "plannedEndTime",
          formatter: (val) => {
            if (val) {
              return val.replace('00:00:00', '')
            } return val
          },
          width: 140
        },
        {
          label: "任务人天",
          prop: "disposableHumanNature",
        },
        {
          label: "任务剩余人天",
          prop: "taskDayDiff",
        },
        {
          label: "累计确认人天",
          prop: "verifyHumanNature",
        },
        {
          label: "任务执行状态",
          prop: "taskState",
          query: {
            type: "select",
            data: [{
              label: '待审批',
              value: 'D'
            }, {
              label: '已分配',
              value: 'N'
            }, {
              label: '已完成',
              value: 'Y'
            }, {
              label: '回退',
              value: 'T'
            }, {
              label: '已转交',
              value: 'C'
            }]
          }
        }
      ],
      week: {},
      subLoading: false,
      offset: 20
    };
  },
  created() {
    this.week = this.getCurrentWeekStartTimeAndEndTime()
    const index = this.tableHead.findIndex(i => i.prop === 'plannedStartTime')
    this.tableHead[index].query.value = [parseTime(this.week.startTime, '{y}-{m}-{d} {h}:{i}:{s}'), parseTime(this.week.endTime, '{y}-{m}-{d} {h}:{i}:{s}')]
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit().then(res => {
        // this.list = res.data.records.map(i => {
        //   i.canCheck = this.isDuringDate(i.plannedStartTime, this.week.startTime, this.week.endTime)
        // })
      });
    });
  },
  methods: {
    // 导出
    downloadExcel() {
      downloadExcel('/bizTaskDetailed/get/excel',this._query,'任务清单')
    },
    dataTableSearch(val, status) {
      this.page = 1
      if (val) {
        const params = {}
        if (val.plannedStartTime) {
          params.startDate = val.plannedStartTime[0]
          params.endDate = val.plannedStartTime[1]
        }
        this._query = Object.assign(params, val)
      }
      if (!status) {
        this.dataTableInit()
      }
    },
    dataTableBeforeInit() {
      this._url = "/bizTaskDetailed/detailedList";
      const params = { page: this.page, size: this.offset,};
      this._params = Object.assign(params, this._query);
      return true;
    },
    selectable(row) {
      // if (!this.isDuringDate(row.plannedStartTime, this.week.startTime, this.week.endTime)) {
      //   return false
      // } else
      if (row.taskState !== 'D') {
        return false
      } return true
    },
    batchDraft() {
      this.submit('N')
    },
    batchRej() {
      this.submit('T')
    },
    submit(taskState) {
      const selection = this.$refs.editTable.$refs.elTable.$refs.refElTable.selection
      if (selection && selection.length) {
        const params = {
          jobIds: selection.map(i => i.id),
          taskState: taskState
        }
        this.$confirm('请确认是否提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.subLoading = true
          updateState(params).then(() => {
            this.dataTableInit()
          }).finally(() => {
            this.subLoading = false
          })
        })
      } else {
        this.$notify({ title: "未选择数据", type: "warning", duration: 1500 });
      }
    },
    /**
     * [isDuringDate 比较时间是否在指定日期范围内]
     * @param date 需判断的时间
     * @param beginDateStr [beginDateStr] [开始日期]
     * @param endDateStr [endDateStr]   [结束日期]
     * @return   Boolean
     */
    isDuringDate(date, beginDateStr, endDateStr) {
      const curDate = new Date(date);
      const beginDate = new Date(beginDateStr);
      const endDate = new Date(endDateStr);
      if (curDate >= beginDate && curDate <= endDate) {
        return true;
      }
      return false;
    },
    startTime(time) {
      const nowTimeDate = new Date(time);
      return nowTimeDate.setHours(0, 0, 0, 0);
    },
    endTime(time) {
      const nowTimeDate = new Date(time);
      return nowTimeDate.setHours(23, 59, 59, 999);
    },
    getCurrentWeekStartTimeAndEndTime(time) {
      const current = time || new Date();
      // current是本周的第几天
      let nowDayOfWeek = current.getDay();
      if (nowDayOfWeek === 0) nowDayOfWeek = 7;
      const dayNum = 1 * 24 * 60 * 60 * 1000;
      // 获取本周星期一的时间，星期一作为一周的第一天
      const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
      // 获取本周星期天的时间，星期天作为一周的最后一天
      const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
      console.log(parseTime(this.startTime(firstDate), '{y}-{m}-{d} {h}:{i}:{s}'))
      console.log(parseTime(this.endTime(lastDate), '{y}-{m}-{d} {h}:{i}:{s}'))
      return {
        startTime: new Date(this.startTime(firstDate)),
        endTime: new Date(this.endTime(lastDate)),
      };
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .filter-item {
    margin-top: 10px;
  }
}
</style>
